import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import defaultAvatar from "../../../../src/assets/images/placeholder.jpg";
// import swal from "sweetalert";
import {
  fetchPatientQueue,
  setSelectedPatient,
  processPayment,
} from "../../../store/actions/CounsellorActions";
import { updateDurationAction } from "../../../store/actions/PrescriptionAction";
// import { ToastContainer, toast } from "react-toastify";
import icon3 from "../../../../src/assets/images/medical-report.png"
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../components/Common/Loader";
import {
  handleError,
  handleSuccess,
  showErrorAlert,
} from "../../../services/ErrorHandlingService";
import { fetchCounsellorDashboardAction } from "../../../store/actions/DashboardCardAction";
import SendPaymentLinkButton from "../Common/SendPaymentLinkButton";
import { formatName } from "../../../utils/formatName";
import UploadReportButton from "../Common/UploadReportButton";
import axiosInstance from "../../../services/AxiosInstance";
import { getObjectionAction } from "../../../store/actions/ObjectionAction";
import { updatePatientObjectionsAction } from "../../../store/actions/PatientObjectionReducer";
import { updatePatientObjectionsService } from "../../../services/PatientObjectionService";

const Counsellor = () => {
  const dispatch = useDispatch();

  // Redux state
  const { patientQueue, selectedPatient, loading, error } = useSelector(
    (state) => state.counsellor
  );
  const dashboardData = useSelector((state) => {
    // console.log("Dashboard Data:", state.dashboard.counsellorDashboard)
    return state?.dashboard?.counsellorDashboard || {};
  });

  // const objections = useSelector((state) => state.objectionReducer);
  const objections = useSelector(
    (state) => state.objection?.list || []
  );
  console.log("Objections from redux:", objections);

  // Local state
  const [duration, setDuration] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [paymentMode, setPaymentMode] = useState("");
  const [amount, setAmount] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [finalAmount, setFinalAmount] = useState(null);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isPanchakarmaRecommended = true   // ✅ STATIC
  const [panchakarmaMode, setPanchakarmaMode] = useState("offline")

  const [karmaEnabled, setKarmaEnabled] = useState(false)
  const [upkarmaEnabled, setUpkarmaEnabled] = useState(false)

  const [karmaData, setKarmaData] = useState({
    startDate: "",
    days: "",
  })

  const [upkarmaData, setUpkarmaData] = useState({
    startDate: "",
    days: "",
  })

  // const [therapyMeta, setTherapyMeta] = useState({
  //   virechan: { startDate: "", days: "" },
  //   vaman: { startDate: "", days: "" },
  //   basti: { startDate: "", days: "" },
  // })

  const [panchakarmaPaymentType, setPanchakarmaPaymentType] = useState("");



  const dayOptions = Array.from({ length: 30 }, (_, i) => ({
    value: i + 1,
    label: `${i + 1} Days`,
  }))

  const karmaOptions = [
    { key: "virechan", label: "Virechan" },
    { key: "vaman", label: "Vaman" },
    { key: "basti", label: "Basti" },
  ];

  const upkarmaOptions = [
    { key: "ghrutpan", label: "Ghrutpan" },
    { key: "lagu", label: "Lagu Vaman" },
    { key: "kadhyachi", label: "Kadhyachi Basti" },
    { key: "dudhachi", label: "Dudhachi Basti" },
  ];


  const [mainOptions, setMainOptions] = useState([])

  const [virechanChecked, setVirechanChecked] = useState(false)
  const [vamanChecked, setVamanChecked] = useState(false)
  const [bastiChecked, setBastiChecked] = useState(false)

  const [virechanSubs, setVirechanSubs] = useState({ ghrutpan: false })
  const [vamanSubs, setVamanSubs] = useState({ lagu: false })
  const [bastiSubs, setBastiSubs] = useState({
    kadhyachi: false,
    dudhachi: false,
  })


  const [paymentType, setPaymentType] = useState("");

  const paymentTypeOptions = [
    { value: "Full", label: "Full Payment" },
    { value: "Partial", label: "Part Payment" },
    { value: "Advance", label: "Advance Payment" },
  ];

  // New state for calculated medicines and total
  const [calculatedMedicines, setCalculatedMedicines] = useState([]);
  const [calculatedTotal, setCalculatedTotal] = useState(0);
  const [defaultDurationWeeks, setDefaultDurationWeeks] = useState(4); // will be set from API

  const initialTherapyMeta = {
    virechan: { checked: false, startDate: "", days: "" },
    vaman: { checked: false, startDate: "", days: "" },
    basti: { checked: false, startDate: "", days: "" },

    ghrutpan: { checked: false, startDate: "", days: "" },
    lagu: { checked: false, startDate: "", days: "" },
    kadhyachi: { checked: false, startDate: "", days: "" },
    dudhachi: { checked: false, startDate: "", days: "" },
  };
  const panchakarmaPaymentOptions = [
    { value: "full", label: "Full Payment" },
    { value: "part", label: "Part Payment" },
    { value: "advance", label: "Advance Payment" },
  ];

  const [therapyMeta, setTherapyMeta] = useState(initialTherapyMeta);

  const selectedPrescription = useSelector(
    (state) => state.medical?.selectedPrescription
  );
  // Duration options - will be dynamically created based on default duration
  const getDurationLabel = (value) => {
    const month = Math.floor(value);
    const fraction = value - month;

    const days =
      fraction === 0.25 ? 7 :
        fraction === 0.5 ? 15 :
          fraction === 0.75 ? 22 : 0;

    if (month === 0) return `${days} Days`;
    if (days === 0) return `${month} Month${month > 1 ? "s" : ""}`;

    return `${month} Month${month > 1 ? "s" : ""} ${days} Days`;
  };

  const durationOptions = Array.from({ length: 12 * 4 }, (_, i) => {
    const value = (i + 1) * 0.25;

    if (value > 12) return null;

    return {
      value: value.toString(),
      label: getDurationLabel(value),
    };
  }).filter(Boolean);
  const [showObjectionModal, setShowObjectionModal] = useState(false);
  const [selectedObjections, setSelectedObjections] = useState([]);


  const formatDuration = (value) => {
    if (!value) return "-";
    return getDurationLabel(parseFloat(value));
  };
  // const staticObjections = [
  //   "Patient does not agree with dosage",
  //   "Patient says medicine is too costly",
  //   "Patient says symptoms still persist",
  //   "Patient wants alternate medicine",
  //   "Patient refused treatment advice"
  // ];

  const [patientsData, setPatientsData] = useState([]);

  const getFinalAmount = (prescription, total) => {
    if (!prescription) return total;

    const discountType = prescription.discount_type;
    const discountValue = parseFloat(prescription.discount_amount || 0);

    if (!discountType || discountValue <= 0) return total;

    if (discountType === "Amount") {
      return total - discountValue;
    }

    if (discountType === "Percentage") {
      return total - (total * discountValue) / 100;
    }

    return total;
  };

  const disableActions =
    selectedPatient?.prescription?.is_valid === "No";

  useEffect(() => {
    if (showObjectionModal) {
      dispatch(getObjectionAction());
    }
  }, [showObjectionModal, dispatch]);
  const openObjectionModal = () => {
    setShowObjectionModal(true);
    dispatch(getObjectionAction());
  };
  useEffect(() => {
    setMainOptions([
      {
        key: "virechan",
        label: "Virechan",
        checked: virechanChecked,
        setChecked: setVirechanChecked,
        subs: virechanSubs,
        setSubs: setVirechanSubs,
      },
      {
        key: "vaman",
        label: "Vaman",
        checked: vamanChecked,
        setChecked: setVamanChecked,
        subs: vamanSubs,
        setSubs: setVamanSubs,
      },
      {
        key: "basti",
        label: "Basti",
        checked: bastiChecked,
        setChecked: setBastiChecked,
        subs: bastiSubs,
        setSubs: setBastiSubs,
      },
    ])
  }, [
    virechanChecked,
    vamanChecked,
    bastiChecked,
    virechanSubs,
    vamanSubs,
    bastiSubs,
  ])

  const handleObjectionChange = async (objection) => {
    try {
      const objectionId = objection.objection_id || objection.id;
      let updated;

      const isSelected = selectedObjections.includes(objectionId);

      if (isSelected) {
        updated = selectedObjections.filter((id) => id !== objectionId);
      } else {
        updated = [...selectedObjections, objectionId];
      }

      setSelectedObjections(updated);

      // ✅ patient_id pass करा
      await updatePatientObjectionsService(
        selectedPatient?.patient_id,
        updated
      );

      handleSuccess("Objection updated successfully");

    } catch (error) {
      console.error("Error updating objection:", error);
      showErrorAlert(
        error?.response?.data?.message || "Failed to update objection"
      );
    }
  };

  // Fetch patient queue data on component mount
  useEffect(() => {
    dispatch(fetchPatientQueue());
    dispatch(fetchCounsellorDashboardAction());
  }, [dispatch]);

  const patientsPrescriptions = dashboardData.patientsPrescriptions || 0;
  // Set default selected patient (first patient with prescription if none selected)
  useEffect(() => {
    const patientsWithPrescriptions = patientQueue
      .filter(
        (patient) =>
          patient?.prescription?.medicines &&
          patient.prescription.medicines.length > 0
      )
      .sort((a, b) => {
        const aTime = new Date(a.prescription.created_at || 0).getTime();
        const bTime = new Date(b.prescription.created_at || 0).getTime();
        return bTime - aTime;
      });

    if (patientQueue.length > 0 && patientsWithPrescriptions.length > 0) {
      dispatch(setSelectedPatient(patientsWithPrescriptions[0]));
    }
    console.log("QUEUE:", patientQueue);
    console.log("FILTERED:", patientsWithPrescriptions);
  }, [patientQueue]); // ✅ ONLY this

  // Initialize calculated medicines when selected patient changes
  useEffect(() => {
    if (
      selectedPatient?.prescription?.medicines &&
      selectedPatient.prescription.medicines.length > 0 &&
      (calculatedMedicines.length === 0 ||
        calculatedMedicines[0]?.prescription_medicine_id !==
        selectedPatient.prescription.medicines[0]?.prescription_medicine_id)
    ) {
      const apiDurationWeeks = selectedPatient.prescription.duration || 4;
      setDefaultDurationWeeks(apiDurationWeeks);

      // Set default duration selection from API
      const defaultDurationOption = {
        value: apiDurationWeeks.toString(),
        label: formatDuration(apiDurationWeeks),
      };
      setDuration(defaultDurationOption);

      // const isPanchakarmaRecommended =
      //   selectedPatient?.prescription?.panchakarma_recommended === "Yes";

      // Initialize medicines with default values
      const initialMedicines = selectedPatient.prescription.medicines.map(
        (medicine) => {
          const defaultQty = parseFloat(medicine.qty || 1);
          const basePrice = parseFloat(medicine.base_price || 0);

          // Calculate initial amount (qty * base_price + GST)
          const baseTotal = basePrice * defaultQty;
          const cgst = parseFloat(medicine.CGST || 0);
          const sgst = parseFloat(medicine.SGST || 0);
          const gstRate = cgst + sgst;
          const gstAmount = baseTotal * (gstRate / 100);
          const totalAmount = baseTotal + gstAmount;

          return {
            ...medicine,
            original_qty: defaultQty,
            original_duration_weeks: apiDurationWeeks,
            calculated_edit_qty: defaultQty,
            calculated_item_gst_price: totalAmount,
            updated_qty: defaultQty, // <-- Ensure updated_qty is set to qty by default
          };
        }
      );

      setCalculatedMedicines(initialMedicines);

      // Calculate initial total
      const total = initialMedicines.reduce(
        (sum, medicine) => sum + medicine.calculated_item_gst_price,
        0
      );
      setCalculatedTotal(total);
      const final = getFinalAmount(selectedPatient?.prescription, total);
      setAmount(final.toFixed(2));
    }
  }, [selectedPatient]);

  // Recalculate medicines when duration changes
  // useEffect(() => {
  //   if (duration && calculatedMedicines.length > 0) {
  //     const selectedDurationWeeks = parseInt(duration.value);

  //     const recalculatedMedicines = calculatedMedicines.map((medicine) => {
  //       // Check if medicine is custom
  //       const isCustom = medicine.is_custom === "Yes";

  //       if (isCustom) {
  //         // For custom medicines, keep the original quantity and don't recalculate
  //         const originalQty = parseFloat(
  //           medicine.original_qty || medicine.qty || 1
  //         );
  //         const basePrice = parseFloat(medicine.base_price || 0);

  //         // Calculate amount with original quantity (no duration-based recalculation)
  //         const baseTotal = basePrice * originalQty;
  //         const cgst = parseFloat(medicine.CGST || 0);
  //         const sgst = parseFloat(medicine.SGST || 0);
  //         const gstRate = cgst + sgst;
  //         const gstAmount = baseTotal * (gstRate / 100);
  //         const newItemGstPrice = baseTotal + gstAmount;

  //         return {
  //           ...medicine,
  //           calculated_edit_qty: originalQty, // Keep original quantity for custom medicines
  //           calculated_item_gst_price: newItemGstPrice,
  //           updated_qty: originalQty, // Keep original quantity for custom medicines
  //         };
  //       } else {
  //         // For regular medicines, recalculate based on duration
  //         const originalQty = parseFloat(
  //           medicine.original_qty || medicine.qty || 1
  //         );
  //         const originalDurationWeeks =
  //           medicine.original_duration_weeks || defaultDurationWeeks;
  //         const basePrice = parseFloat(medicine.base_price || 0);

  //         // Calculate qty per week: Q / D
  //         const qtyPerWeek = originalQty / originalDurationWeeks;

  //         // Calculate new qty: (Q / D) * d
  //         const newQty = Math.ceil(qtyPerWeek * selectedDurationWeeks);

  //         // Calculate new amount: updated_qty * base_price + GST
  //         const baseTotal = basePrice * newQty;
  //         const cgst = parseFloat(medicine.CGST || 0);
  //         const sgst = parseFloat(medicine.SGST || 0);
  //         const gstRate = cgst + sgst;
  //         const gstAmount = baseTotal * (gstRate / 100);
  //         const newItemGstPrice = baseTotal + gstAmount;

  //         return {
  //           ...medicine,
  //           calculated_edit_qty: newQty,
  //           calculated_item_gst_price: newItemGstPrice,
  //           updated_qty: newQty,
  //         };
  //       }
  //     });

  //     setCalculatedMedicines(recalculatedMedicines);

  //     // Calculate new total
  //     const newTotal = recalculatedMedicines.reduce(
  //       (sum, medicine) => sum + medicine.calculated_item_gst_price,
  //       0
  //     );
  //     setCalculatedTotal(newTotal);
  //     const final = getFinalAmount(selectedPatient?.prescription, newTotal);
  //     setAmount(final.toFixed(2));
  //   }
  // }, [duration, defaultDurationWeeks]);

  useEffect(() => {
    if (duration && calculatedMedicines.length > 0) {
      const selectedDuration = parseFloat(duration.value);

      const recalculatedMedicines = calculatedMedicines.map((medicine) => {
        const isCustom = medicine.is_custom === "Yes";

        if (isCustom) {
          const originalQty = parseFloat(
            medicine.original_qty || medicine.qty || 1
          );
          const basePrice = parseFloat(medicine.base_price || 0);

          const baseTotal = basePrice * originalQty;
          const cgst = parseFloat(medicine.CGST || 0);
          const sgst = parseFloat(medicine.SGST || 0);
          const gstRate = cgst + sgst;
          const gstAmount = baseTotal * (gstRate / 100);
          const newItemGstPrice = baseTotal + gstAmount;

          return {
            ...medicine,
            calculated_edit_qty: originalQty,
            calculated_item_gst_price: newItemGstPrice,
            updated_qty: originalQty,
          };
        } else {
          const originalQty = parseFloat(
            medicine.original_qty || medicine.qty || 1
          );
          const originalDuration =
            medicine.original_duration_weeks || defaultDurationWeeks;
          const basePrice = parseFloat(medicine.base_price || 0);

          // 🔥 MAIN LOGIC
          const qtyPerUnit = originalQty / originalDuration;
          const newQty = Math.ceil(qtyPerUnit * selectedDuration);

          const baseTotal = basePrice * newQty;
          const cgst = parseFloat(medicine.CGST || 0);
          const sgst = parseFloat(medicine.SGST || 0);
          const gstRate = cgst + sgst;
          const gstAmount = baseTotal * (gstRate / 100);
          const newItemGstPrice = baseTotal + gstAmount;

          return {
            ...medicine,
            calculated_edit_qty: newQty,
            calculated_item_gst_price: newItemGstPrice,
            updated_qty: newQty,
          };
        }
      });

      setCalculatedMedicines(recalculatedMedicines);

      const newTotal = recalculatedMedicines.reduce(
        (sum, medicine) => sum + medicine.calculated_item_gst_price,
        0
      );

      setCalculatedTotal(newTotal);

      const final = getFinalAmount(selectedPatient?.prescription, newTotal);
      setAmount(final.toFixed(2));
    }
  }, [duration, defaultDurationWeeks]);

  useEffect(() => {
    if (selectedPatient) {
      console.log("Selected Patient:", selectedPatient);
      console.log("Prescriptions:", selectedPatient.prescription);
      console.log("Default Duration Weeks:", defaultDurationWeeks);
    }
  }, [selectedPatient, defaultDurationWeeks]);

  const validateForm = () => {
    const newErrors = {};
    if (!paymentMode) {
      newErrors.paymentMode = "Payment mode is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (disableActions) return;
    if (!validateForm()) return;

    const amountValue = parseFloat(amount);
    if (amountValue <= 0) {
      handleError("Amount must be greater than 0.");
      return;
    }

    if (!selectedPatient) {
      showErrorAlert("No patient selected.");
      return;
    }

    const paymentData = {
      patient_id: selectedPatient.patient_id,
      queue_id: selectedPatient.queue_id,
      amount: finalAmount !== null ? finalAmount : amountValue,
      final_amount: finalAmount !== null ? finalAmount : amountValue,
      reference_id: selectedPatient.prescription.prescription_id || "",
      coupon_code: couponCode.trim() || "",
      payment_type: paymentMode.toLowerCase(),
      payment_for: "MEDICINE",
    };

    setIsSubmitting(true); // 🔹 Start Loader

    // Set payment status to true locally
    dispatch(
      setSelectedPatient({
        ...selectedPatient,
        prescription: {
          ...selectedPatient.prescription,
          prescription_payment_status: "PAID",
        },
      })
    );

    dispatch(processPayment(paymentData))
      .then(() => {
        handleSuccess("Payment processed successfully!");
        handleClose();
        dispatch(fetchPatientQueue());
        dispatch(fetchCounsellorDashboardAction());
      })
      .catch((error) => {
        // Revert payment status on error
        dispatch(
          setSelectedPatient({
            ...selectedPatient,
            prescription: {
              ...selectedPatient.prescription,
              prescription_payment_status: "PENDING",
            },
          })
        );
        showErrorAlert(`Payment failed: ${error}`);
      })
      .finally(() => {
        setIsSubmitting(false); // 🔹 Stop Loader
      });
  };


  // Quantity changes are now handled through the updateDuration API
  const handleCheckboxChange = async (patientId, field, value) => {
    try {
      // ✅ instant UI update
      dispatch({
        type: "UPDATE_PATIENT_REVIEW",
        payload: { patientId, field, value },
      });

      if (field === "googleReview") {
        await axiosInstance.post("patient/reviewProvided", {
          patient_id: patientId,
          review_provided: value ? "Yes" : "No",
        });
      }

      if (field === "testimonial") {
        await axiosInstance.post("patient/testimonialProvided", {
          patient_id: patientId,
          testimonial_provided: value ? "Yes" : "No",
        });
      }

      handleSuccess("Updated successfully");
    } catch (error) {
      handleError("Update failed");
    }
  };
  const handleChange = (selectedOption) => {
    setDuration(selectedOption);
  };

  const handlePatientSelect = (patient) => {
    // Reset states before dispatching new patient
    setCalculatedMedicines([]);
    setCalculatedTotal(0);
    setAmount("0");
    setDuration(null);
    setDefaultDurationWeeks(4);
    setFinalAmount(null);
    setCouponCode("");
    setPaymentMode("Online");
    setShowModal(false);

    // Set default duration based on patient's prescription
    if (patient?.prescription?.duration) {
      const defaultDurationOption = {
        value: patient.prescription.duration.toString(),
        label: getDurationLabel(patient.prescription.duration),
      };
      setDuration(defaultDurationOption);
      setDefaultDurationWeeks(patient.prescription.duration);
    }

    // Initialize medicines with default values
    if (patient?.prescription?.medicines) {
      const initialMedicines = patient.prescription.medicines.map(
        (medicine) => {
          const defaultQty = parseFloat(medicine.qty || 1);
          const basePrice = parseFloat(medicine.base_price || 0);

          // Calculate initial amount (qty * base_price + GST)
          const baseTotal = basePrice * defaultQty;
          const cgst = parseFloat(medicine.CGST || 0);
          const sgst = parseFloat(medicine.SGST || 0);
          const gstRate = cgst + sgst;
          const gstAmount = baseTotal * (gstRate / 100);
          const totalAmount = baseTotal + gstAmount;

          return {
            ...medicine,
            original_qty: defaultQty,
            original_duration_weeks: patient.prescription.duration || 4,
            calculated_edit_qty: defaultQty,
            calculated_item_gst_price: totalAmount,
          };
        }
      );

      setCalculatedMedicines(initialMedicines);

      // Calculate initial total
      const total = initialMedicines.reduce(
        (sum, medicine) => sum + medicine.calculated_item_gst_price,
        0
      );
      setCalculatedTotal(total);
      const final = getFinalAmount(selectedPatient?.prescription, total);
      setAmount(final.toFixed(2));
    }

    // Dispatch new patient selection
    dispatch(setSelectedPatient(patient));
  };
  const getValidPhotoUrl = (photoUrl) => {
    if (!photoUrl || photoUrl.trim() === "") return defaultAvatar;

    // Fix duplicate "https://"
    if ((photoUrl.match(/https:\/\//g) || []).length > 1) {
      const parts = photoUrl.split("https://");
      photoUrl = "https://" + parts[parts.length - 1];
    }

    // If not a full URL, prepend your API base
    if (!photoUrl.startsWith("http")) {
      const baseUrl = process.env.REACT_APP_API_URL || "https://yourdomain.com";
      photoUrl = `${baseUrl}/uploads/patient_photos/${photoUrl}`;
    }

    return photoUrl;
  };

  const handleUpdateDuration = async () => {
    if (disableActions) {
      return;
    }
    if (!selectedPatient || !selectedPatient.prescription) {
      showErrorAlert("No prescription found for this patient");
      return;
    }

    // Show a loading indicator
    // swal({
    //   title: "Processing...",
    //   text: "Updating prescription details",
    //   icon: "info",
    //   buttons: false,
    //   closeOnClickOutside: false,
    //   closeOnEsc: false,
    //   content: (
    //     <div className="text-center">
    //       <Loader size="lg" />
    //     </div>
    //   ),
    // });

    try {
      // Calculate GST amounts
      const prescription = selectedPatient.prescription;

      const updateDurationData = {
        patient_id: selectedPatient.patient_id,
        prescription_id: prescription.prescription_id,
        // duration: duration ? parseInt(duration.value) : 30,
        duration: duration ? parseFloat(duration.value) : 1,
        updated_qty: JSON.stringify(
          calculatedMedicines.map((medicine) => ({
            prescription_medicine_id: medicine.prescription_medicine_id,
            updated_qty: medicine.calculated_edit_qty.toString(),
            base_price: medicine.base_price || "0",
            CGST: medicine.CGST || "0",
            SGST: medicine.SGST || "0",
            IGST: medicine.IGST || "0",
            cgst_sgst_price: medicine.cgst_sgst_price || "0",
            igst_price: medicine.igst_price || "0",
            item_cgst_amount: medicine.item_cgst_amount || "0",
            item_sgst_amount: medicine.item_sgst_amount || "0",
            item_igst_amount: medicine.item_igst_amount || "0",
            item_gst_price: medicine.calculated_item_gst_price.toString(),
            item_igst_price: medicine.item_igst_price || "0",
            item_subtotal: medicine.item_subtotal || "0",
          }))
        ),
        items_subtotal: prescription.items_subtotal,
        items_cgst_amount: prescription.items_cgst_amount,
        items_sgst_amount: prescription.items_sgst_amount,
        items_igst_amount: prescription.items_igst_amount,
        gst_price: calculatedTotal.toString(),
        igst_price: prescription.igst_price,
      };

      // Call updateDuration API
      const result = await dispatch(updateDurationAction(updateDurationData));

      // Close the loading indicator
      // swal.close();

      if (result && result.status === "success") {
        // If updateDuration succeeds, show payment modal with updated amount
        const updatedAmount = calculatedTotal;
        // setAmount(updatedAmount.toString());
        const final = getFinalAmount(selectedPatient?.prescription, updatedAmount);
        setAmount(final.toFixed(2));
        setFinalAmount(null); // Reset any previous coupon applications
        setCouponCode(""); // Reset coupon code
        setPaymentMode(""); // Reset payment mode
        setShowModal(true);
      } else {
        throw new Error(
          result?.message || "Failed to update prescription details"
        );
      }
    } catch (error) {
      console.error("Error in handleUpdateDuration:", error);
      showErrorAlert(
        error.message ||
        "Failed to update prescription details. Please try again."
      );
    }
  };

  const handleClose = () => setShowModal(false);

  const handleApplyCoupon = () => {
    const amt = parseFloat(amount);
    if (!amt || amt <= 0) {
      handleError("Enter a valid amount before applying the coupon.");
      return;
    }

    if (couponCode.trim() === "") {
      handleError("Please enter a valid coupon code.");
      return;
    }

    // Apply coupon logic - for now setting to 0 as in original
    setFinalAmount(0);
  };

  const subtotal =
    parseFloat(selectedPatient?.prescription?.items_subtotal || 0) +
    parseFloat(selectedPatient?.prescription?.items_cgst_amount || 0) +
    parseFloat(selectedPatient?.prescription?.items_sgst_amount || 0);

  const finalAmountWithDiscount = getFinalAmount(
    selectedPatient?.prescription,
    subtotal
  );

  const payableAmount = getFinalAmount(
    selectedPatient?.prescription,
    calculatedTotal
  );

  // Tooltip content for info icon
  const renderTooltip = (props) => {
    // Calculate totals
    const itemsBreakdown = calculatedMedicines.map((medicine) => {
      const basePrice = parseFloat(medicine.base_price || 0);
      const qty = medicine.calculated_edit_qty || 0;
      const itemSubtotal = basePrice * qty;
      const cgstRate = parseFloat(medicine.CGST || 0);
      const sgstRate = parseFloat(medicine.SGST || 0);
      const igstRate = parseFloat(medicine.IGST || 0);

      return {
        name: medicine.medicine_name,
        qty: qty,
        basePrice: basePrice,
        itemSubtotal: itemSubtotal,
        cgst: itemSubtotal * (cgstRate / 100),
        sgst: itemSubtotal * (sgstRate / 100),
        // igst: itemSubtotal * (igstRate / 100),
        cgstRate,
        sgstRate,
        igstRate,
      };
    });

    const prescription = selectedPatient?.prescription || {};

    // const subtotal = parseFloat(prescription.items_subtotal || 0);
    const subtotal = calculatedMedicines.reduce((sum, med) => {
      const basePrice = parseFloat(med.base_price || 0);
      const qty = med.calculated_edit_qty || 0;
      return sum + basePrice * qty;
    }, 0);
    const cgstTotal = calculatedMedicines.reduce((sum, med) => {
      const base = med.base_price * med.calculated_edit_qty;
      return sum + (base * (parseFloat(med.CGST || 0) / 100));
    }, 0);

    const sgstTotal = calculatedMedicines.reduce((sum, med) => {
      const base = med.base_price * med.calculated_edit_qty;
      return sum + (base * (parseFloat(med.SGST || 0) / 100));
    }, 0);

    const discountType = prescription.discount_type;
    const discountValue = parseFloat(prescription.discount_amount || 0);

    // 🔹 Step 1: Discount on Item Total
    let discountAmount = 0;

    if (discountType === "Amount") {
      discountAmount = discountValue;
    } else if (discountType === "Percentage") {
      discountAmount = (subtotal * discountValue) / 100;
    }

    // 🔹 Step 2: Discounted Amount
    const discountedSubtotal = subtotal - discountAmount;

    // 🔹 Step 3: Tax on discounted amount
    const cgstOnDiscounted = discountedSubtotal * (parseFloat(itemsBreakdown[0]?.cgstRate || 0) / 100);
    const sgstOnDiscounted = discountedSubtotal * (parseFloat(itemsBreakdown[0]?.sgstRate || 0) / 100);

    const totalTax = cgstOnDiscounted + sgstOnDiscounted;

    // 🔹 Step 4: Final total
    const finalPayable = discountedSubtotal + totalTax;

    return (
      <Tooltip id="bill-tooltip" {...props} className="custom-tooltip">
        <style>
          {`
            .custom-tooltip.tooltip > .tooltip-inner {
              background-color: transparent;
              padding: 0;
              border: none;
              max-width: none;
            }
            .custom-tooltip.tooltip > .tooltip-arrow {
              display: none;
            }
            .custom-tooltip.tooltip.show {
              opacity: 1;
            }
          `}
        </style>
        <div
          style={{
            textAlign: "left",
            minWidth: "380px",
            padding: "20px",
            backgroundColor: "#ffffff",
            color: "#333333",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
            fontFamily: "Arial, sans-serif",
          }}
        >
          {/* Header */}
          <div
            style={{
              borderBottom: "1px solid rgba(0,0,0,0.2)",
              paddingBottom: "15px",
              marginBottom: "15px",
            }}
          >
            <h6
              style={{
                margin: "0",
                color: "#333333",
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              Bill Details
            </h6>
          </div>

          {/* Bill Summary */}
          <div>
            {/* Item Total */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "14px",
                marginBottom: "12px",
                color: "#333333",
              }}
            >
              <span>Item Total</span>
              <span style={{ fontWeight: "500" }}>₹{subtotal.toFixed(2)}</span>
            </div>

            {/* Discount */}
            {discountAmount > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "12px",
                  color: "#28a745",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                <span>
                  Discount {discountType === "Percentage" ? `(${discountValue}%)` : ""}
                </span>
                <span>- ₹{discountAmount.toFixed(2)}</span>
              </div>
            )}

            {/* Discounted Subtotal */}
            {discountAmount > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "12px",
                  color: "#333",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                <span>Subtotal after Discount</span>
                <span>₹{discountedSubtotal.toFixed(2)}</span>
              </div>
            )}

            {/* Taxes Section */}
            <div
              style={{
                backgroundColor: "rgba(0,0,0,0.05)",
                padding: "12px",
                borderRadius: "8px",
                margin: "15px 0",
              }}
            >
              <div
                style={{
                  marginBottom: "10px",
                  color: "#333333",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Taxes and Charges
              </div>

              {/* Always show all tax types */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "8px",
                  color: cgstTotal > 0 ? "#333333" : "rgba(0,0,0,0.5)",
                  fontSize: "13px",
                }}
              >
                <span>CGST @ {itemsBreakdown[0]?.cgstRate || 0}%</span>
                {/* <span>₹{cgstTotal.toFixed(2)}</span> */}
                <span>₹{cgstOnDiscounted.toFixed(2)}</span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "8px",
                  color: sgstTotal > 0 ? "#333333" : "rgba(0,0,0,0.5)",
                  fontSize: "13px",
                }}
              >
                <span>SGST @ {itemsBreakdown[0]?.sgstRate || 0}%</span>
                {/* <span>₹{sgstTotal.toFixed(2)}</span> */}
                <span>₹{sgstOnDiscounted.toFixed(2)}</span>
              </div>

              {/* <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  color: igstTotal > 0 ? "#333333" : "rgba(0,0,0,0.5)",
                  fontSize: "13px",
                }}
              >
                <span>IGST @ {itemsBreakdown[0]?.igstRate || 0}%</span>
                <span>₹{igstTotal.toFixed(2)}</span>
              </div> */}

              {/* Total Tax */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "8px",
                  paddingTop: "8px",
                  borderTop: "1px solid rgba(0,0,0,0.2)",
                  fontWeight: "500",
                  color: "#333333",
                  fontSize: "13px",
                }}
              >
                <span>Total Tax</span>
                <span>₹{totalTax.toFixed(2)}</span>
              </div>
            </div>
            {/* Discount */}
            {/* {discountAmount > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                  color: "#28a745",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                <span>
                  Discount {discountType === "Percentage" ? `(${discountValue}%)` : ""}
                </span>
                <span>- ₹{discountAmount.toFixed(2)}</span>
              </div>
            )} */}

            {/* Grand Total */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "16px",
                fontWeight: "600",
                marginTop: "15px",
                paddingTop: "15px",
                borderTop: "1px solid rgba(0,0,0,0.2)",
                color: "#333333",
              }}
            >
              <span>Grand Total</span>
              {/* <span>₹{finalPayable.toFixed(2)}</span> */}
              <span>₹{Math.round(finalPayable)}</span>
            </div>
          </div>
        </div>
      </Tooltip>
    );
  };
  const paymentOptions = [
    { value: "Online", label: "Online" },
    { value: "Bankingcard", label: "Banking Card" },
    { value: "Upi", label: "UPI" },
    { value: "Offline", label: "Cash" },
  ];
  // Update the statistics count
  const patientsWithPrescriptions = patientQueue.filter(
    (patient) =>
      patient?.prescription?.medicines &&
      patient.prescription.medicines.length > 0
  );
  const totalPatients = patientsWithPrescriptions.length;
  const handleOpen = (patient_id) => {
    window.open(`/case-paper/${patient_id}`, "_blank");
  };
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "400px" }}
      >
        <Loader size="lg" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        Error loading patient data: {error}
      </div>
    );
  }

  const FIELD_HEIGHT = "42px";
  const compactSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: FIELD_HEIGHT,
      height: FIELD_HEIGHT,
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 10px",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: FIELD_HEIGHT,
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
  };

  const handleDragStart = (e, index, isSubOption = false, subKey = null) => {
    const dragData = { index, isSubOption, subKey }
    e.dataTransfer.setData("text/plain", JSON.stringify(dragData))
  }

  const allowDrop = (e) => e.preventDefault()

  const handleDrop = (e, dropIndex, isSubOption = false, parentIndex = null) => {
    e.preventDefault()
    const dragDataStr = e.dataTransfer.getData("text/plain")
    if (!dragDataStr) return

    const dragData = JSON.parse(dragDataStr)

    if (dragData.isSubOption && isSubOption && parentIndex !== null) {
      const updated = [...mainOptions]
      const parent = updated[parentIndex]
      const subEntries = Object.entries(parent.subs)

      const [dragged] = subEntries.splice(dragData.index, 1)
      subEntries.splice(dropIndex, 0, dragged)

      const reordered = Object.fromEntries(subEntries)
      parent.subs = reordered
      setMainOptions(updated)

      if (parentIndex === 0) setVirechanSubs(reordered)
      if (parentIndex === 1) setVamanSubs(reordered)
      if (parentIndex === 2) setBastiSubs(reordered)
    } else {
      const updated = [...mainOptions]
      const [removed] = updated.splice(dragData.index, 1)
      updated.splice(dropIndex, 0, removed)
      setMainOptions(updated)
    }
  }


  const TherapyRow = ({ item }) => {
    const meta = therapyMeta[item.key];

    return (
      <div className="d-flex align-items-center gap-3 mb-2">

        {/* Label */}
        <label className="fw-semibold" style={{ minWidth: "120px" }}>
          {item.label}
        </label>

        {/* Start Date */}
        <input
          type="date"
          className="form-control form-control-sm"
          style={{ width: "150px" }}
          value={meta.startDate}
          onChange={(e) =>
            setTherapyMeta((prev) => ({
              ...prev,
              [item.key]: {
                ...prev[item.key],
                startDate: e.target.value,
              },
            }))
          }
        />

        {/* Days */}
        <Select
          options={dayOptions}
          placeholder="Days"
          value={dayOptions.find((d) => d.value === meta.days) || null}
          onChange={(selected) =>
            setTherapyMeta((prev) => ({
              ...prev,
              [item.key]: {
                ...prev[item.key],
                days: selected ? selected.value : "",
              },
            }))
          }
          styles={{
            control: (base) => ({
              ...base,
              minHeight: "36px",
              width: "140px",
            }),
            menu: (base) => ({
              ...base,
              zIndex: 9999,
            }),
          }}
        />
      </div>
    );
  };


  return (
    <>
      <div>
        <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
          <div className="me-auto d-none d-lg-block">
            <h3 className="text-black font-w600">Welcome to Rohati Ayurved!</h3>
          </div>
        </div>

        {/* Statistics Cards */}
        <div className="row">
          <div className="col-xl-3 col-xxl-6 col-sm-6">
            <div className="card gradient-bx text-white bg-info rounded">
              <div className="card-body">
                <div className="media align-items-center">
                  <div className="media-body">
                    <p className="mb-1">Patients with Prescriptions</p>
                    <div className="d-flex flex-wrap">
                      <h2 className="fs-40 font-w600 text-white mb-0 me-3">
                        {patientsPrescriptions}
                      </h2>
                    </div>
                  </div>
                  <span className="border rounded-circle p-4">
                    <svg
                      width={34}
                      height={34}
                      viewBox="0 0 38 38"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M37.3333 15.6666C37.3383 14.7488 37.0906 13.8473 36.6174 13.061C36.1441 12.2746 35.4635 11.6336 34.6501 11.2084C33.8368 10.7831 32.9221 10.5899 32.0062 10.65C31.0904 10.7101 30.2087 11.021 29.4579 11.5489C28.707 12.0767 28.1159 12.8011 27.7494 13.6425C27.3829 14.484 27.255 15.4101 27.3799 16.3194C27.5047 17.2287 27.8774 18.086 28.4572 18.7976C29.0369 19.5091 29.8013 20.0473 30.6667 20.3533V25.6666C30.6667 27.8768 29.7887 29.9964 28.2259 31.5592C26.6631 33.122 24.5435 34 22.3333 34C20.1232 34 18.0036 33.122 16.4408 31.5592C14.878 29.9964 14 27.8768 14 25.6666V23.8666C16.7735 23.4642 19.3097 22.0777 21.1456 19.9603C22.9815 17.8429 23.9946 15.1358 24 12.3333V2.33329C24 1.89127 23.8244 1.46734 23.5118 1.15478C23.1993 0.842221 22.7754 0.666626 22.3333 0.666626H17.3333C16.8913 0.666626 16.4674 0.842221 16.1548 1.15478C15.8423 1.46734 15.6667 1.89127 15.6667 2.33329C15.6667 2.77532 15.8423 3.19924 16.1548 3.5118C16.4674 3.82436 16.8913 3.99996 17.3333 3.99996H20.6667V12.3333C20.6667 14.5434 19.7887 16.663 18.2259 18.2258C16.6631 19.7887 14.5435 20.6666 12.3333 20.6666C10.1232 20.6666 8.00358 19.7887 6.44077 18.2258C4.87797 16.663 4 14.5434 4 12.3333V3.99996H7.33333C7.77536 3.99996 8.19928 3.82436 8.51184 3.5118C8.8244 3.19924 9 2.77532 9 2.33329C9 1.89127 8.8244 1.46734 8.51184 1.15478C8.19928 0.842221 7.77536 0.666626 7.33333 0.666626H2.33333C1.8913 0.666626 1.46738 0.842221 1.15482 1.15478C0.842259 1.46734 0.666664 1.89127 0.666664 2.33329V12.3333C0.672024 15.1358 1.68515 17.8429 3.52106 19.9603C5.35697 22.0777 7.8932 23.4642 10.6667 23.8666V25.6666C10.6667 28.7608 11.8958 31.7283 14.0837 33.9162C16.2717 36.1041 19.2391 37.3333 22.3333 37.3333C25.4275 37.3333 28.395 36.1041 30.5829 33.9162C32.7708 31.7283 34 28.7608 34 25.6666V20.3533C34.9723 20.0131 35.8151 19.3797 36.4122 18.5402C37.0092 17.7008 37.3311 16.6967 37.3333 15.6666Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Patient List and Prescription Section */}
        <div className="row mb-3 g-3 justify-content-center">
          <div className="col-12 col-lg-4">
            <div
              className="card border-0 pb-0"
              style={{ borderRadius: "10px" }}
            >
              <div
                className="card-header border-0 pb-0"
                style={{
                  borderTopLeftRadius: "10px",
                  borderTopRightRadius: "10px",
                }}
              >
                <h4 className="card-title">Patients</h4>
              </div>
              <div className="card-body">
                <div
                  className="widget-media dz-scroll"
                  style={{ borderRadius: "10px" }}
                >
                  {patientsWithPrescriptions.length > 0 ? (
                    <ul className="timeline">
                      {patientsWithPrescriptions.map((patient) => {
                        const displayPatient = {
                          ...patient,
                          name: formatName(
                            patient.name ||
                            `${patient.first_name || ""} ${patient.last_name || ""
                              }`.trim() ||
                            "N/A"),
                          disease: patient.diseases || "General Checkup",
                          doctor: patient.prescription.prescribed_by || "N/A",
                          time: patient.time_slot || "N/A",
                          // avatar: patient.patient_photo || defaultAvatar,
                          avatar: getValidPhotoUrl(patient.patient_photo),

                        };

                        return (
                          <li
                            key={patient.patient_id || patient.queue_id}
                            style={{
                              backgroundColor:
                                patient.patient_id ===
                                  selectedPatient?.patient_id
                                  ? "#d4edf7"
                                  : "transparent",
                              padding: "10px 15px",
                              marginBottom: "10px",
                              borderRadius: "10px",
                              cursor: "pointer",
                            }}
                            onClick={() => handlePatientSelect(patient)}
                          >
                            <div
                              className="timeline-panel d-flex align-items-start flex-wrap py-2"
                              style={{ borderRadius: "10px" }}
                            >
                              {/* Avatar Section */}
                              {/* <div className="me-3 mb-2">
                                <Link
                                  to={`/patients/patient-details/${displayPatient.patient_id}`}
                                >
                                  <img
                                    alt="avatar"
                                    width="50"
                                    src={displayPatient.avatar}
                                    className="rounded-circle"
                                    style={{
                                      objectFit: "cover",
                                      width: "50px",
                                      height: "50px",
                                    }}
                                  />
                                </Link>
                              </div> */}
                              <div className="me-3 mb-2">
                                <Link to={`/patients/patient-details/${displayPatient.patient_id}`}>
                                  <img
                                    alt="avatar"
                                    width="50"
                                    height="50"
                                    src={
                                      displayPatient?.avatar && displayPatient.avatar.trim() !== ""
                                        ? displayPatient.avatar
                                        : defaultAvatar
                                    }
                                    onError={(e) => {
                                      // ✅ If image fails to load (bad URL), fallback to default
                                      e.target.onerror = null;
                                      e.target.src = defaultAvatar;
                                    }}
                                    className="rounded-circle"
                                    style={{
                                      objectFit: "cover",
                                      width: "50px",
                                      height: "50px",
                                    }}
                                  />
                                </Link>
                              </div>


                              {/* Patient Info Section */}
                              <div className="flex-grow-1">
                                <div className="d-flex justify-content-between align-items-center w-100 mb-1">
                                  <h5 className="mb-0">{displayPatient.name}</h5>

                                  <img
                                    src={icon3 || "/placeholder.svg"}
                                    alt="patient icon"
                                    style={{
                                      cursor: "pointer",
                                      width: "30px",
                                      height: "30px",
                                      objectFit: "contain",
                                    }}
                                    title="case-paper"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleOpen(displayPatient.patient_id);
                                    }}
                                  />
                                </div>

                                <p className="mb-1">Disease: {displayPatient.disease}</p>
                                <p className="mb-1">Doctor: {displayPatient.doctor}</p>

                                <div className="d-flex flex-wrap gap-2 mt-2 align-items-center">
                                  {/* View Prescription Button */}
                                  <button
                                    className="btn btn-info btn-xxs"
                                    style={{
                                      padding: "4px 12px",
                                      borderRadius: "5px",
                                      fontSize: "12px",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handlePatientSelect(patient);
                                    }}
                                  >
                                    View Prescription
                                  </button>

                                  <div className="form-check" style={{ fontSize: "12px" }}>
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={patient.review_provided === "Yes"}
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        handleCheckboxChange(
                                          patient.patient_id,
                                          "googleReview",
                                          e.target.checked
                                        );
                                      }}
                                    />
                                    <label className="form-check-label">Google Review</label>
                                  </div>

                                  <div className="form-check" style={{ fontSize: "12px" }}>
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={patient.testimonial_provided === "Yes"}
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        handleCheckboxChange(
                                          patient.patient_id,
                                          "testimonial",
                                          e.target.checked
                                        );
                                      }}
                                    />
                                    <label className="form-check-label">Testimonial</label>
                                  </div>
                                </div>
                              </div>


                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  ) : (
                    <div className="text-center py-4">
                      <div className="alert alert-info" role="alert">
                        <i className="fa fa-info-circle fa-2x mb-3"></i>
                        <h5>No Patient with Prescriptions</h5>
                        <p className="mb-0">
                          There are no patients with prescriptions at the
                          moment.
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-8 col-xxl-8 col-lg-8">
            {patientsWithPrescriptions.length > 0 ? (
              <div className="card border-0 pb-0">
                <div className="card-header border-0 pb-0 d-flex flex-wrap justify-content-between align-items-center">
                  <h4 className="card-title mb-2 mb-md-0" style={{ flex: 1 }}>
                    Prescription
                    {disableActions && (
                      <span className="badge bg-danger ms-2">
                        Invalid Prescription
                      </span>
                    )}
                  </h4>

                  <div className="text-right d-flex flex-wrap align-items-center">

                    <div className="me-3">
                      <UploadReportButton />
                    </div>


                    <p
                      className="patient-name mb-2 mb-md-0 me-md-3"
                      style={{ marginBottom: "0", fontSize: "14px" }}
                    >
                      <strong>Patient Name:</strong>{" "}
                      {formatName(selectedPatient?.name ||
                        `${selectedPatient?.first_name || ""} ${selectedPatient?.last_name || ""
                          }`.trim() ||
                        "N/A")}
                    </p>
                    <p
                      className="disease mb-0"
                      style={{ fontSize: "14px", textAlign: "right" }}
                    >
                      <strong>Disease:</strong>{" "}
                      {selectedPatient?.diseases || "General Checkup"}
                    </p>

                  </div>
                </div>
                <div className="card-body">
                  {/* Duration Selection Section */}
                  <div className="row mb-4 align-items-center">
                    <div className="col-lg-3 col-md-4 col-sm-12 mb-2 mb-md-0">
                      <label
                        className="form-label mb-0 me-2"
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          backgroundColor: "#f0f4ff",
                          color: "#0056b3",
                          padding: "6px 12px",
                          borderRadius: "6px",
                          whiteSpace: "nowrap",
                          display: "inline-block",
                        }}
                      >
                        Prescription Duration:
                      </label>
                    </div>
                    <div className="col-lg-4 col-md-8 col-sm-12">
                      <Select
                        name="duration"
                        options={durationOptions}
                        value={duration}
                        onChange={handleChange}
                        placeholder="Select Duration"
                        classNamePrefix="react-select"
                        isDisabled={disableActions}
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            minHeight: "36px",
                            height: "36px",
                            fontSize: "14px",
                            borderColor: state.isFocused
                              ? "#007bff"
                              : "#ced4da",
                            boxShadow: state.isFocused
                              ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                              : "none",
                            transition: "all 0.2s ease",
                            borderRadius: "5px",
                            zIndex: 0,
                          }),
                          singleValue: (provided) => ({
                            ...provided,
                            lineHeight: "36px",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                          dropdownIndicator: (provided) => ({
                            ...provided,
                            padding: "4px",
                          }),
                          indicatorSeparator: () => ({ display: "none" }),
                        }}
                      />
                    </div>

                  </div>

                  {/* Prescription Section */}
                  {selectedPatient ? (
                    selectedPatient.prescription ? (
                      <div>
                        <div className="d-flex justify-content-between align-items-center mb-3"></div>

                        {/* Separate medicines into custom and non-custom */}
                        {(() => {
                          const regularMedicines = calculatedMedicines.filter(
                            (medicine) => medicine.is_custom === "No"
                          );
                          const customMedicines = calculatedMedicines.filter(
                            (medicine) => medicine.is_custom === "Yes"
                          );


                          return (
                            <>
                              {/* Regular Medicines Table */}
                              {regularMedicines.length > 0 && (
                                <div
                                  className="table-responsive"
                                  style={{
                                    border: "2px solid #ddd",
                                    borderRadius: "5px",
                                    marginTop: "20px",
                                    marginBottom: "24px",
                                    overflowX: "auto",
                                  }}
                                >
                                  <table
                                    className="table table-striped mb-0"
                                    style={{
                                      minWidth: "850px", // ensures scroll on smaller screens
                                    }}
                                  >
                                    <thead className="table-light">
                                      <tr className="table-info text-center">
                                        {[
                                          "MEDICINE NAME",
                                          "DOSE",
                                          "FREQUENCY",
                                          "QUANTITY",
                                          "EDIT QTY",
                                          "HOW TO TAKE?",
                                          "AMOUNT",
                                        ].map((header) => (
                                          <th
                                            key={header}
                                            style={{
                                              padding: "15px 10px",
                                              fontWeight: "bold",
                                              minWidth:
                                                header === "MEDICINE NAME"
                                                  ? "180px"
                                                  : header === "FREQUENCY"
                                                    ? "150px"
                                                    : header === "HOW TO TAKE?"
                                                      ? "200px"
                                                      : "100px",
                                            }}
                                          >
                                            {header}
                                          </th>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {regularMedicines.map(
                                        (prescription, index) => {
                                          const prescribedQty =
                                            prescription.qty || 1;
                                          return (
                                            <tr
                                              key={`regular-${prescription.prescription_medicine_id ||
                                                index
                                                }`}
                                              className="text-center"
                                            >
                                              <td>
                                                <strong>
                                                  {prescription.medicine_name ||
                                                    "Unknown Medicine"}
                                                </strong>
                                              </td>
                                              <td>
                                                {prescription.dose || "1"}
                                              </td>
                                              <td>
                                                {prescription.frequency || "1"}
                                              </td>
                                              <td>{prescribedQty}</td>
                                              <td>
                                                <span
                                                  className={
                                                    duration &&
                                                      parseInt(duration.value) !==
                                                      defaultDurationWeeks
                                                      ? "badge bg-warning"
                                                      : "badge bg-info"
                                                  }
                                                >
                                                  {prescription.calculated_edit_qty ||
                                                    prescription.qty ||
                                                    "N/A"}
                                                </span>
                                              </td>
                                              <td>
                                                {prescription.how_to_take ||
                                                  prescription.howToTake ||
                                                  prescription.instructions ||
                                                  "Take as directed by doctor"}
                                              </td>
                                              {/* <td>
                                                <strong
                                                  className={
                                                    duration &&
                                                      parseInt(duration.value) !==
                                                      defaultDurationWeeks
                                                      ? "text-success"
                                                      : ""
                                                  }
                                                >
                                                  ₹{(
                                                    parseFloat(prescription.base_price || 0) *
                                                    parseFloat(prescription.calculated_edit_qty || 0)
                                                  ).toFixed(2)}
                                                </strong>
                                              </td> */}

                                              <td>
                                                <div style={{ lineHeight: "1.2" }}>
                                                  
                                                  <strong
                                                    className={
                                                      duration &&
                                                        parseInt(duration.value) !== defaultDurationWeeks
                                                        ? "text-success"
                                                        : ""
                                                    }
                                                  >
                                                    ₹{(
                                                      parseFloat(prescription.base_price || 0) *
                                                      parseFloat(prescription.calculated_edit_qty || 0)
                                                    ).toFixed(2)}
                                                  </strong>
                                                </div>
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              )}

                              {/* Custom Medicines Table */}
                              {customMedicines.length > 0 && (
                                <div
                                  className="table-responsive"
                                  style={{
                                    border: "2px solid #ddd",
                                    borderRadius: "5px",
                                    marginBottom: "0",
                                    overflowX: "auto", // Horizontal scroll on small screens
                                  }}
                                >
                                  <h5 className="p-2 border-bottom mb-0">
                                    Custom Medicines
                                  </h5>
                                  <table
                                    className="table table-striped mb-0"
                                    style={{
                                      minWidth: "800px", // Ensures horizontal scroll
                                      borderCollapse: "collapse",
                                      width: "100%",
                                    }}
                                  >
                                    <thead
                                      style={{
                                        position: "sticky",
                                        top: 0,
                                        backgroundColor: "#f8f9fa",
                                        //zIndex: 10,
                                        borderBottom: "2px solid #ddd",
                                      }}
                                    >
                                      <tr className="table-info">
                                        {[
                                          "MEDICINE NAME",
                                          "DOSE",
                                          "FREQUENCY",
                                          "QUANTITY",
                                          "EDIT QTY",
                                          "DURATION",
                                          "HOW TO TAKE?",
                                          "AMOUNT",
                                        ].map((header) => (
                                          <th
                                            key={header}
                                            className="text-center"
                                            style={{
                                              padding: "15px 10px",
                                              //color: "black",
                                              fontWeight: "bold",
                                              verticalAlign: "middle",
                                              minWidth:
                                                header === "MEDICINE NAME"
                                                  ? "180px"
                                                  : header === "FREQUENCY"
                                                    ? "150px"
                                                    : header === "HOW TO TAKE?"
                                                      ? "200px"
                                                      : header === "DURATION"
                                                        ? "100px"
                                                        : header === "DOSE"
                                                          ? "80px"
                                                          : "100px",
                                            }}
                                          >
                                            {header}
                                          </th>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {customMedicines.map(
                                        (prescription, index) => {
                                          const prescribedQty =
                                            prescription.qty || 1;

                                          return (
                                            <tr
                                              key={`custom-${prescription.prescription_medicine_id ||
                                                index
                                                }`}
                                            >
                                              <td className="text-center align-middle">
                                                <strong>
                                                  {prescription.medicine_name ||
                                                    "Unknown Medicine"}
                                                </strong>
                                              </td>
                                              <td className="text-center align-middle">
                                                {prescription.dose || "1"}
                                              </td>
                                              <td className="text-center align-middle">
                                                <div className="small">
                                                  {prescription.frequency ||
                                                    "1"}
                                                </div>
                                              </td>
                                              <td className="text-center align-middle">
                                                {prescribedQty}
                                              </td>
                                              <td className="text-center align-middle">
                                                <span
                                                  className={
                                                    duration &&
                                                      parseInt(duration.value) !==
                                                      defaultDurationWeeks
                                                      ? "badge bg-warning"
                                                      : "badge bg-info"
                                                  }
                                                >
                                                  {prescription.calculated_edit_qty ||
                                                    prescription.qty ||
                                                    "N/A"}
                                                </span>
                                              </td>
                                              <td className="text-center align-middle">
                                                {prescription.custom_duration_in_days ||
                                                  "N/A"}
                                              </td>
                                              <td className="text-center align-middle">
                                                <div className="small text-wrap">
                                                  {prescription.how_to_take ||
                                                    prescription.howToTake ||
                                                    prescription.instructions ||
                                                    "Take as directed by doctor"}
                                                </div>
                                              </td>
                                              <td className="text-center align-middle">
                                                <strong
                                                  className={
                                                    duration &&
                                                      parseInt(duration.value) !==
                                                      defaultDurationWeeks
                                                      ? "text-success"
                                                      : ""
                                                  }
                                                >
                                                  ₹{(
                                                    parseFloat(prescription.base_price || 0) *
                                                    parseFloat(prescription.calculated_edit_qty || 0)
                                                  ).toFixed(2)}
                                                </strong>
                                              </td>

                                              {/* <td>
                                                <div style={{ lineHeight: "1.2" }}>
                                                  <small style={{ color: "#888" }}>
                                                    {parseFloat(prescription.base_price || 0)} ×{" "}
                                                    {parseFloat(prescription.calculated_edit_qty || 0)}
                                                  </small>
                                                  <br />
                                                  <strong
                                                    className={
                                                      duration &&
                                                        parseInt(duration.value) !== defaultDurationWeeks
                                                        ? "text-success"
                                                        : ""
                                                    }
                                                  >
                                                    ₹{(
                                                      parseFloat(prescription.base_price || 0) *
                                                      parseFloat(prescription.calculated_edit_qty || 0)
                                                    ).toFixed(2)}
                                                  </strong>
                                                </div>
                                              </td> */}
                                            </tr>
                                          );
                                        }
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              )}

                              {/* Show message if no medicines */}
                              {regularMedicines.length === 0 &&
                                customMedicines.length === 0 && (
                                  <div className="text-center text-muted py-4">
                                    No medicines prescribed
                                  </div>
                                )}
                            </>
                          );
                        })()}
                        {/* Show Notes */}
                        {/* Notes */}
                        <div className="mb-3 mt-3">

                          {/* 🔹 Pathyas Field (added before Notes) */}
                          <label className="form-label"><strong>Pathyas:</strong></label>
                          <p className="form-control bg-light">
                            {selectedPatient.prescription?.pathyas || "No pathyas available"}
                          </p>

                          {/* 🔹 Notes Field (existing) */}
                          <label className="form-label mt-3"><strong>Notes:</strong></label>
                          <p className="form-control bg-light">
                            {selectedPatient.prescription?.note || "No notes available"}
                          </p>

                          <div className="d-flex justify-content-between align-items-center mt-3">

                            {/* Left: Total Amount */}
                            <div
                              className="d-flex align-items-center gap-2"
                              style={{ fontSize: "18px" }}
                            >
                              <strong>
                                Medicine Total Amount: ₹{payableAmount.toFixed(2)}
                              </strong>

                              <OverlayTrigger
                                placement="top"
                                delay={{ show: 250, hide: 400 }}
                                overlay={renderTooltip}
                              >
                                <span
                                  style={{
                                    cursor: "pointer",
                                    color: "#007bff",
                                    fontSize: "16px",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "50%",
                                    backgroundColor: "#e7f3ff",
                                    border: "1px solid #007bff",
                                  }}
                                  title="Click for calculation details"
                                >
                                  ℹ
                                </span>
                              </OverlayTrigger>
                            </div>

                            {/* Right: Button */}
                            <button
                              className="btn btn-warning"
                              onClick={disableActions ? undefined : openObjectionModal}
                              style={{
                                pointerEvents: disableActions ? "none" : "auto",
                                opacity: disableActions ? 0.6 : 1,
                              }}
                            >
                              Objections
                            </button>

                          </div>


                          {/* {
                            isPanchakarmaRecommended && (
                              <div
                                className="alert alert-success d-flex align-items-center mb-3"
                                style={{
                                  borderLeft: "5px solid #28a745",
                                  backgroundColor: "#e9f7ef",
                                }}
                              >
                                <strong className="me-2">✔ Panchakarma Recommended</strong>
                                <span>for this patient</span>
                              </div>
                            )
                          } */}
                          {/* {
                            isPanchakarmaRecommended && (
                              <div className="mb-3">
                                <label className="form-label fw-bold">
                                  Panchakarma Mode
                                </label>

                                <div className="d-flex gap-4">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="panchakarmaMode"
                                      id="pkOnline"
                                      value="online"
                                      checked={panchakarmaMode === "online"}
                                      onChange={(e) => setPanchakarmaMode(e.target.value)}
                                    />
                                    <label className="form-check-label" htmlFor="pkOnline">
                                      Online
                                    </label>
                                  </div>

                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="panchakarmaMode"
                                      id="pkOffline"
                                      value="offline"
                                      checked={panchakarmaMode === "offline"}
                                      onChange={(e) => setPanchakarmaMode(e.target.value)}
                                    />
                                    <label className="form-check-label" htmlFor="pkOffline">
                                      Offline
                                    </label>
                                  </div>
                                </div>
                              </div>
                            )
                          } */}

                          <div className="mb-3">
                            {/* <label className="form-label fw-bold mb-2">Panchakarma Plan</label> */}

                            <div className="row">
                              {/* Karma */}
                              {/* <div className="col-md-6">
                                <h6 className="fw-bold mb-2">Karma</h6>
                                <div className="border rounded p-3 bg-light">
                                  {karmaOptions.map((item) => (
                                    <TherapyRow key={item.key} item={item} />
                                  ))}
                                </div>
                              </div> */}

                              {/* Upkarma */}
                              {/* <div className="col-md-6">
                                <h6 className="fw-bold mb-2">Upkarma</h6>
                                <div className="border rounded p-3 bg-light">
                                  {upkarmaOptions.map((item) => (
                                    <TherapyRow key={item.key} item={item} />
                                  ))}
                                </div>
                              </div> */}
                            </div>
                          </div>

                          {/* 🔹 Objection button */}
                          {/* <button
                            className="btn btn-warning mt-2"
                            onClick={() => setShowObjectionModal(true)}
                          >
                            View Objections
                          </button> */}
                        </div>


                        <div className="mt-4">
                          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">

                            {/* <div className="form-group mt-3">
                              <label className="form-label fw-bold">
                                Panchakarma Payment Type <span className="text-danger">*</span>
                              </label>

                              <Select
                                options={panchakarmaPaymentOptions}
                                placeholder="Select Payment Type"
                                value={
                                  panchakarmaPaymentOptions.find(
                                    (opt) => opt.value === panchakarmaPaymentType
                                  ) || null
                                }
                                onChange={(selected) =>
                                  setPanchakarmaPaymentType(selected ? selected.value : "")
                                }
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    minHeight: "45px",
                                    borderColor: !panchakarmaPaymentType
                                      ? "#dc3545"
                                      : state.isFocused
                                        ? "#86b7fe"
                                        : base.borderColor,
                                    boxShadow: "none",
                                  }),
                                  menu: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                isClearable
                              />

                              {!panchakarmaPaymentType && (
                                <small className="text-danger">Please select payment type</small>
                              )}
                            </div> */}

                            {/* Save Button */}
                            <div className="text-md-end">
                              {selectedPatient.prescription?.prescription_payment_status !== "PAID" &&
                                !showModal && (
                                  <>
                                    {/* Later Button */}
                                    {/* <Link
                                      to="#"
                                      className="btn btn-secondary me-2"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        // You can add your logic here to handle "Later"
                                        // For now just show alert or console
                                        console.log("Prescription marked to save later");
                                      }}
                                    >
                                      Save Later
                                    </Link> */}

                                    {/* Save & Collect Payment Button */}
                                    <Link
                                      to="#"
                                      className="btn btn-info"
                                      onClick={disableActions ? undefined : handleUpdateDuration}
                                      style={{
                                        pointerEvents: disableActions ? "none" : "auto",
                                        opacity: disableActions ? 0.6 : 1,
                                      }}
                                    >
                                      Save & Collect Payment
                                    </Link>
                                  </>
                                )}
                            </div>

                          </div>

                          <Modal
                            show={showModal}
                            onHide={() => {
                              handleClose();
                              // Refresh patient queue to get latest payment status
                              // dispatch(fetchPatientQueue());
                            }}
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>Collect Payment</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <form onSubmit={handleSubmit}>
                                <div className="form-group mt-3">
                                  <label htmlFor="amount">Amount</label>
                                  <input
                                    type="number"
                                    placeholder="Enter the Amount"
                                    className="form-control"
                                    id="amount"
                                    // value={Number(amount).toFixed(2)}
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                    min="0.01"
                                    step="0.01"
                                    required
                                  />
                                </div>
                                {/* <div className="form-group">
                                  <label htmlFor="paymentMode">
                                    Payment Mode<span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="paymentMode"
                                    value={paymentMode}
                                    onChange={(e) =>
                                      setPaymentMode(e.target.value)
                                    }
                                    required
                                  >
                                    <option value="" disabled>
                                      -- Select Payment Mode --
                                    </option>
                                    <option value="Online">Online</option>
                                    <option value="Bankingcard">
                                      Banking Card
                                    </option>
                                    <option value="Upi">UPI</option>
                                    <option value="Offline">Cash</option>
                                  </select>
                                  {errors.paymentMode && (
                                    <small className="text-danger">{errors.paymentMode}</small>
                                  )}
                                </div> */}
                                {/* <div className="form-group mt-3">
                                  <label htmlFor="paymentType">
                                    Panchkarma Payment Type <span className="text-danger">*</span>
                                  </label>

                                  <Select
                                    id="paymentType"
                                    name="paymentType"
                                    options={paymentTypeOptions}
                                    placeholder="Select Payment Type"
                                    value={
                                      paymentTypeOptions.find(
                                        (option) => option.value === paymentType
                                      ) || null
                                    }
                                    onChange={(selectedOption) => {
                                      setPaymentType(selectedOption ? selectedOption.value : "");
                                    }}
                                    styles={{
                                      control: (base, state) => ({
                                        ...base,
                                        minHeight: "50px",
                                        borderColor: state.isFocused ? "#86b7fe" : base.borderColor,
                                        boxShadow: "none",
                                      }),
                                      menu: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    isClearable
                                  />
                                </div> */}
                                <div className="form-group">
                                  <label htmlFor="paymentMode">
                                    Payment Mode <span className="text-danger">*</span>
                                  </label>

                                  <Select
                                    id="paymentMode"
                                    name="paymentMode"
                                    options={paymentOptions}
                                    placeholder="Select Payment Mode"
                                    value={
                                      paymentOptions.find((option) => option.value === paymentMode) || null
                                    }
                                    onChange={(selectedOption) => {
                                      setPaymentMode(selectedOption ? selectedOption.value : "");
                                      setErrors((prev) => ({ ...prev, paymentMode: "" })); // ✅ clear error on change
                                    }}
                                    styles={{
                                      control: (base, state) => ({
                                        ...base,
                                        minHeight: "50px",
                                        borderColor: errors.paymentMode
                                          ? "#dc3545" // red if error
                                          : state.isFocused
                                            ? "#86b7fe" // blue when focused
                                            : base.borderColor,
                                        boxShadow: "none",
                                        "&:hover": {
                                          borderColor: errors.paymentMode ? "#dc3545" : "#86b7fe",
                                        },
                                      }),
                                      menu: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />

                                  {errors.paymentMode && (
                                    <small className="text-danger">{errors.paymentMode}</small>
                                  )}
                                </div>

                                {paymentMode === "Offline" && (
                                  <>
                                    <div className="form-group mt-2">
                                      <label htmlFor="coupon">
                                        Coupon Code
                                      </label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          id="coupon"
                                          value={couponCode}
                                          onChange={(e) =>
                                            setCouponCode(e.target.value)
                                          }
                                          disabled={finalAmount !== null}
                                        />
                                        {finalAmount === null ? (
                                          <button
                                            type="button"
                                            className="btn btn-outline-primary"
                                            onClick={handleApplyCoupon}
                                          >
                                            Apply
                                          </button>
                                        ) : (
                                          <button
                                            type="button"
                                            className="btn btn-outline-danger"
                                            onClick={() => {
                                              setCouponCode("");
                                              setFinalAmount(null);
                                            }}
                                          >
                                            Cancel
                                          </button>
                                        )}
                                      </div>
                                    </div>

                                    {finalAmount !== null && (
                                      <div className="my-3">
                                        <strong>
                                          Final Amount: ₹{finalAmount}
                                        </strong>{" "}
                                        <span className="text-success">
                                          (Coupon Applied)
                                        </span>
                                      </div>
                                    )}
                                  </>
                                )}
                                {/* <div className="d-flex justify-content-between align-items-center mt-4">
                                  <SendPaymentLinkButton
                                    patientId={selectedPatient.patient_id}
                                    prescriptionId={
                                      selectedPatient.prescription
                                        ?.prescription_id
                                    }
                                    patientName={selectedPatient.name}
                                    amount={amount || calculatedTotal}
                                    paymentFor="Medicine"
                                    paymentType="counsellor"
                                    className="btn me-2"
                                
                                    variant="outline-primary"
                                    style={{
                                      backgroundColor: "#17a2b8",
                                      borderColor: "#17a2b8",
                                      color: "white",
                                      fontWeight: "500",
                                    }}
                                    onSuccess={() => setShowModal(false)}
                                  />
                                  <Button
                                    type="submit"
                                    style={{
                                      background: "#007680",
                                      border: "none",
                                    }}
                                  >
                                    Collect Payment
                                  </Button>
                                </div> */}
                                <div className="d-flex justify-content-between align-items-center mt-4">
                                  <SendPaymentLinkButton
                                    patientId={selectedPatient.patient_id}
                                    prescriptionId={selectedPatient.prescription?.prescription_id}
                                    patientName={selectedPatient.name}
                                    // amount={amount || calculatedTotal}
                                    amount={payableAmount}
                                    paymentFor="Medicine"
                                    paymentType="counsellor"
                                    className="btn me-2"
                                    onSuccess={() => setShowModal(false)}
                                  />
                                  <Button
                                    type="submit"
                                    style={{
                                      background: "#007680",
                                      border: "none",
                                      padding: "6px 20px",
                                      fontSize: "16px",
                                      fontWeight: "500",
                                      borderRadius: "6px",
                                      minHeight: "52px",
                                      lineHeight: "1.5",
                                      color: "white",
                                    }}
                                    disabled={isSubmitting} // disable while processing
                                  >
                                    {isSubmitting ? (
                                      <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Processing...
                                      </>
                                    ) : (
                                      "Collect Payment"
                                    )}
                                  </Button>
                                </div>

                              </form>
                            </Modal.Body>
                          </Modal>
                        </div>
                      </div>
                    ) : (
                      <div className="text-center py-5">
                        <div className="alert alert-warning" role="alert">
                          <i className="fa fa-exclamation-triangle fa-2x mb-3"></i>
                          <h5>No Prescriptions Found</h5>
                          <p className="mb-0">
                            This patient doesn&apos;t have any prescriptions
                            available yet.
                          </p>
                        </div>
                      </div>
                    )
                  ) : (
                    <div className="text-center py-5">
                      <div
                        className="alert alert-info"
                        role="alert"
                        style={{
                          maxWidth: "600px",
                          margin: "0 auto",
                          borderRadius: "10px",
                          padding: "30px",
                        }}
                      >
                        <div style={{ marginBottom: "25px" }}>
                          <i
                            className="fa fa-clipboard-list fa-4x"
                            style={{ color: "#17a2b8" }}
                          ></i>
                        </div>
                        <h4 className="alert-heading mb-4">
                          No Prescriptions Available
                        </h4>
                        <div
                          style={{
                            backgroundColor: "#f8f9fa",
                            padding: "20px",
                            borderRadius: "8px",
                            marginBottom: "15px",
                          }}
                        >
                          <p
                            className="mb-3"
                            style={{ fontSize: "16px", color: "#495057" }}
                          >
                            There are currently no patients with prescriptions
                            in the system.
                          </p>
                          <p
                            className="mb-0"
                            style={{ fontSize: "14px", color: "#6c757d" }}
                          >
                            New prescriptions will appear here once they are
                            added by the doctors.
                          </p>
                        </div>
                        <div
                          style={{
                            marginTop: "20px",
                            fontSize: "14px",
                            color: "#6c757d",
                          }}
                        >
                          <i className="fa fa-info-circle me-2"></i>
                          Please check back later.
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="card border-0 pb-0">
                <div className="card-body">
                  <div className="text-center py-5">
                    <div
                      className="alert alert-info"
                      role="alert"
                      style={{
                        maxWidth: "600px",
                        margin: "0 auto",
                        borderRadius: "10px",
                        padding: "30px",
                      }}
                    >
                      <div style={{ marginBottom: "25px" }}>
                        <i
                          className="fa fa-clipboard-list fa-4x"
                          style={{ color: "#17a2b8" }}
                        ></i>
                      </div>
                      <h4 className="alert-heading mb-4">
                        No Prescriptions Available
                      </h4>
                      <div
                        style={{
                          padding: "20px",
                          borderRadius: "8px",
                          marginBottom: "15px",
                        }}
                      >
                        <p
                          className="mb-3"
                          style={{ fontSize: "16px", color: "#495057" }}
                        >
                          There are currently no patients with prescriptions in
                          the system.
                        </p>
                        <p
                          className="mb-0"
                          style={{ fontSize: "14px", color: "#6c757d" }}
                        >
                          New prescriptions will appear here once they are added
                          by the doctors.
                        </p>
                      </div>
                      <div
                        style={{
                          marginTop: "20px",
                          fontSize: "14px",
                          color: "#6c757d",
                        }}
                      >
                        <i className="fa fa-info-circle me-2"></i>
                        Please check back later
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Modal show={showObjectionModal} onHide={() => setShowObjectionModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Objections</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {objections.length > 0 ? (
            objections.map((item, index) => (
              <div key={item.objection_id} className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`objection-${index}`}
                  checked={selectedObjections.includes(item.objection_id)}
                  onChange={() => handleObjectionChange(item)}
                />

                <label
                  className="form-check-label"
                  htmlFor={`objection-${index}`}
                >
                  {item.objection_text}
                </label>
              </div>
            ))
          ) : (
            <p>No objections found</p>
          )}
        </Modal.Body>
      </Modal>

    </>
  );
};

export default Counsellor;

